<!-- HSK判断题 -->
<template>
  <div class="ques-area">
    <div class="ques-area-des" v-if="descriptionText">{{ serial ? serial + ". " : "" }}{{ descriptionText }}</div>
    <div class="example" v-if="!isSPC">
      {{ jsonData.is_example ? $t("hsk_example") : jsonData.index }}
    </div>
    <div class="panel-content">
      <slot></slot>
      <div v-for="(item, index) in jsonData.screen_text" :key="index" :class="`text-ques--${item.type}`">
        <img v-if="item.type == 'image'" :src="baseUrl + item.content + '?width=300'" alt="" />

        <PhoneticText
          v-else-if="item.type == 'html' || item.type == 'text'"
          :originData="item.content"
          :baseStyles="{
            ...textStyles(item),
            hzFontSize: '16px',
            hzLineHeight: '24px',
          }"
          :showPinyin="item.display != 1"
          :onlyPinyin="item.display == 2"
          :class="getTextLength(item.type, item.content) ? 'sentence' : 'word'"
        ></PhoneticText>
        <div v-else-if="item.type == 'syllable'" :class="getTextLength(item.type, item.content) ? 'sentence' : 'word'">
          {{ item.content }}
        </div>
      </div>
      <div class="panel-content-answers">
        <ul class="list-answers" ref="answers">
          <li
            v-for="(item, index) in answers"
            :class="[
              'item-answer',
              {
                success: isShowAnAnalysis && item.correct,
                error: isShowAnAnalysis && !item.correct && isError && myAnswerText === item.flag,
                selected: (!isShowAnAnalysis && item.selected) || (jsonData.is_example && item.correct),
              },
            ]"
            :key="`${jsonData.index}_${index}`"
            :data-correct="item.correct ? 1 : 0"
            ref="answer"
            @click="handleCheck($event, item)"
          >
            <div class="text">
              <i v-if="item.flag == 'T'" class="el-icon-check judgment-icon"></i>
              <i v-else class="el-icon-close judgment-icon"></i>
            </div>
          </li>
        </ul>
      </div>
      <!-- 解析 -->
      <div class="panel-content-result result-correct" v-if="isShowAnAnalysis && !isError && !jsonData.is_example">
        <p class="correct-tips">
          {{ $t("textbook_chioce_word_text_correct_tip") }}
        </p>
        <div class="correct-box" v-show="analysisText">
          <p class="correct-box-title">{{ $t("hsk_answer_analysis") }}</p>
          <p class="correct-box-answer">
            {{ analysisText }}
          </p>
        </div>
      </div>

      <div class="panel-content-result result-error" v-if="isShowAnAnalysis && isError && !jsonData.is_example">
        <p class="error-tips">
          {{ $t("textbook_chioce_word_text_error_tip") }}
        </p>
        <div class="result-show">
          <div class="your-answer">
            {{ $t("hsk_your_answer") }}
            <i v-if="myAnswerText == 'T'" class="el-icon-check answer-icon"></i>
            <i v-if="myAnswerText == 'F'" class="el-icon-close answer-icon"></i>
          </div>
          <p class="correct-answer">
            {{ $t("hsk_correct_answer") }}
            <i v-if="successAnswerText == 'T'" class="el-icon-check answer-icon"></i>
            <i v-if="successAnswerText == 'F'" class="el-icon-close answer-icon"></i>
          </p>
        </div>
        <div class="correct-box" v-show="analysisText">
          <p class="correct-box-title">{{ $t("hsk_answer_analysis") }}</p>
          <p class="correct-box-answer">
            {{ analysisText }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PhoneticText from "@/components/ui/phoneticText";
import { mixinCommon } from "@/mixins";
const parser = new DOMParser();
export default {
  name: "CommonJudgment",
  components: { PhoneticText },
  mixins: [mixinCommon],
  data() {
    return {};
  },
  computed: {
    isError() {
      let flag = "";
      if (this.jsonData.answer) {
        for (let i = 0; i < this.jsonData.answers.length; i++) {
          if (this.jsonData.answers[i].correct && this.jsonData.answers[i].id == this.jsonData.answer) {
            flag = this.jsonData.answers[i].id;
            break;
          }
        }
      }
      return this.jsonData.answer != flag || (this.jsonData.answer == "" && this.jsonData.answer != undefined);
    },
    successAnswerText() {
      let flag = "";
      for (let i = 0; i < this.jsonData.answers.length; i++) {
        if (this.jsonData.answers[i].correct) {
          flag = this.jsonData.answers[i].flag;
          break;
        }
      }
      return flag;
    },
    myAnswerText() {
      let flag = "";
      if (this.jsonData.answer) {
        for (let i = 0; i < this.jsonData.answers.length; i++) {
          if (this.jsonData.answers[i].index == this.jsonData.answer) {
            flag = this.jsonData.answers[i].flag;
            break;
          }
        }
      }
      return flag;
    },
    analysisText() {
      return this.jsonData.analysis[this.language]
        ? this.jsonData.analysis[this.language]
        : this.jsonData.analysis["zh"];
    },

    answers() {
      return this.jsonData.answers.map((item) => {
        return {
          id: item.index,
          index: item.id,
          ...item,
        };
      });
    },
    language() {
      let local = localStorage.getItem("language");
      return local;
    },
    descriptionText() {
      return this.jsonData.question_description_obj
        ? this.jsonData.question_description_obj[this.language]
          ? this.jsonData.question_description_obj[this.language]
          : this.jsonData.question_description_obj["zh"]
        : "";
    },
  },
  created() {
    console.log(this.jsonData);
    this.jsonData.answers = this.resetAnswerSelected();
    if (this.jsonData.answer) {
      this.jsonData.answers = this.selectedAnswer(this.jsonData.answer);
    }
  },
  watch: {},
  methods: {
    //点击选项
    handleCheck(event, item) {
      if (this.isShowAnAnalysis || this.jsonData.is_example) return;
      this.jsonData.answers = this.selectedAnswer(item.id);
      console.log(this.jsonData.answers);
      const isCorrect = !!parseInt(event.currentTarget.dataset.correct);
      const { index, score, segment_code, part_code, ifGroup } = this.jsonData;
      let params = {
        answer: item.id,
        questionId: index,
        scores: isCorrect ? score : 0,
        judge: isCorrect ? 1 : 0,
        segmentCode: segment_code,
        partCode: part_code,
        ifGroup: ifGroup,
      };
      this.$emit("customInterface", params);
      setTimeout(() => {
        this.$emit("saveRes", params);
      }, 200);
    },
    //重置选项为未点击
    resetAnswerSelected() {
      return this.jsonData.answers.map((item) => {
        item.selected = false;
        return {
          id: item.index,
          index: item.id,
          ...item,
        };
      });
    },
    //点击选项置为true
    selectedAnswer(chooseIndex) {
      return this.jsonData.answers.map((item) => {
        if (chooseIndex == item.id) {
          item.selected = true;
        } else {
          item.selected = false;
        }
        console.log(item);
        return item;
      });
    },
    playAudio() {
      this.$emit("changeShowButtonStatus", "pause");
      this.$player.play(this.baseUrl + this.jsonData.listen.audio_file);
      this.$player.onended = () => {
        this.$emit("changeShowButtonStatus", "play");
      };
    },
    pauseAudio() {
      this.$player.pause();
      this.$emit("changeShowButtonStatus", "play");
    },
    // 计算数字长度以及标点区分是句子还是词语
    // 带标点即为句子,不带标点<=4为词语>4为句子
    getTextLength(type, content) {
      let reg = new RegExp("[\\u4E00-\\u9FFF]+$", "g");
      if (type != "html") {
        if (reg.test(content)) {
          return true;
        } else {
          return content.length > 4;
        }
      } else {
        const xmlDoc = parser.parseFromString(content, "text/xml");
        const chars = xmlDoc.querySelectorAll("font");
        if (chars && chars.length) {
          for (let i = 0; i < chars.length; i++) {
            if (reg.test(chars[i])) {
              return true;
            }
          }
          return chars.length > 4;
        } else {
          return false;
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.ques-area {
  width: 100%;
  position: relative;
  padding-top: 80px;
  &-des {
    position: absolute;
    left: 37px;
    top: 20px;
    font-size: 14px;
    font-weight: 400;
    line-height: 24px;
    color: #b5b5be;
    margin-top: 0px;
  }
  .example {
    background: rgba(63, 70, 81, 1);
    border-radius: 4px;
    color: #fff;
    padding: 5px;
    font-size: 12px;
    position: absolute;
    top: 40px;
    left: 28px;
    min-width: 20px;
    display: flex;
    justify-content: center;
  }
  .panel-content {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0px 29px 0px 29px;
    ::v-deep .sentence {
      text-align: left;
      .normal_pht {
        justify-content: left;
      }
    }
    ::v-deep .word {
      text-align: center;
      .normal_pht {
        justify-content: center;
      }
    }
    img {
      width: 280px;
      height: 158px;
      object-fit: contain;
      border-radius: 5px;
    }
    .phoneticTextBox {
      margin-top: 30px;
    }
    .text-ques {
      width: 100%;
      margin-bottom: 10px;
      &--html {
        width: 100%;
        text-align: center;
        // margin-bottom: 20px;
        ::v-deep .phtContent {
          margin-top: 10px;
          .normal_pht {
            //display: inline-flex;
            .pht_single {
              text-align: start;
            }
          }
        }
      }
      &--text {
        margin-bottom: 10px;
        ::v-deep .phtContent {
          .pht_single {
            text-align: start;
          }
        }
      }
    }
    &-answers {
      width: 100%;
      margin-bottom: 40px;
      margin-top: 20px;
      .list-answers {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
      }

      .item-answer {
        cursor: pointer;
        position: relative;

        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        // flex: 1;

        width: 250px;
        height: 43px;
        line-height: 43px;
        font-size: 16px;
        margin-top: 20px;

        color: rgba(63, 70, 81, 1);
        background: rgba(242, 243, 247, 1);
        border-radius: 6px;
        box-sizing: border-box;

        .text {
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .judgment-icon {
          font-size: 28px;
          font-weight: bold;
          line-height: 44px;
        }
        &:after {
          position: absolute;
          content: "";
          width: 16px;
          height: 16px;
          right: -24px;
          top: 50%;
          transform: translateY(-50%);
          background-position: 0 0;
          background-repeat: no-repeat;
          background-size: cover;
        }
        &.selected {
          border: 2px solid #faae56;
          background: #ffffff;
        }
        &.success {
          background: #ffffff; // 设置白色背景
          border: 1px solid rgba(9, 203, 160, 1);
          color: #09cba0;

          // &:after {
          //   background-image: url(~@/assets/images/icon-test-ok.png);
          // }
        }

        &.error {
          border: 1px solid #fc5a5a;
          color: #fc5a5a;
          background: #ffffff;
          // &:after {
          //   background-image: url(~@/assets/images/icon-test-no.png);
          // }
        }
      }
    }
    &-result {
      padding: 40px 30px 20px 0;
      border-top: 1px dashed #e6eaef;
      width: 100%;
      &.result-error,
      &.result-correct {
        p.error-tips {
          font-size: 14px;
          color: #fc5a5a;
          margin-bottom: 20px;
        }
        p.correct-tips {
          font-size: 14px;
          color: rgba(9, 203, 160, 1);
          margin-bottom: 20px;
        }
        .result-show {
          display: flex;
          align-items: center;
          margin-bottom: 20px;
        }
        .your-answer {
          font-size: 14px;
          font-weight: 500;
          color: rgba(84, 89, 97, 1);
          line-height: 14px;
          .answer-icon {
            font-size: 12px;
          }
        }
        p.correct-answer {
          font-size: 14px;
          font-weight: 500;
          color: rgba(84, 89, 97, 1);
          line-height: 14px;
          margin-left: 45px;
        }
        .correct-box {
          background: #fafafb;
          border-radius: 10px;
          padding: 20px;

          &-title {
            font-size: 14px;
            font-weight: bold;
            color: rgba(63, 70, 81, 1);
            margin-bottom: 10px;
          }
          &-answer {
            font-size: 14px;
            font-weight: 400;
            color: rgba(84, 89, 97, 1);
            line-height: 21px;
            white-space: pre-line;
          }
        }
      }
    }
  }
}
</style>
